var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavouriteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Controls_Icons_Heart",
    "data-name": "Controls/Icons/Heart",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Controls_icon_Heart-Unselected",
    "data-name": "Controls/icon/Heart-Unselected"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2305",
    "data-name": "Rectangle 2305",
    width: 24,
    height: 24,
    fill: "#ccc",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3749",
    "data-name": "Path 3749",
    d: "M36.032,22.129c-.278-4.388-3.028-6.621-5.63-6.888a5.93,5.93,0,0,0-5.72,3.189,5.93,5.93,0,0,0-5.721-3.189c-2.6.267-5.352,2.5-5.629,6.888-.321,5.06,3.5,7.986,10.865,13.143a.842.842,0,0,0,.969,0C32.526,30.115,36.352,27.188,36.032,22.129Zm-11.35,11.39c-6.7-4.706-9.908-7.234-9.652-11.28.214-3.382,2.215-5.091,4.1-5.285a3.635,3.635,0,0,1,.37-.019c1.592,0,3.56,1.023,4.358,3.984a.849.849,0,0,0,1.642,0c.861-3.2,3.078-4.131,4.727-3.965,1.889.193,3.889,1.9,4.1,5.285C34.589,26.283,31.383,28.812,24.682,33.518Z",
    transform: "translate(-12.682 -13.32)",
    fill: "#0098db"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteIcon);
export default __webpack_public_path__ + "static/media/favouriteIcon.febae8d3dc1b613bcde81f6fdd119b54.svg";
export { ForwardRef as ReactComponent };